// import { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// const ScrollToTop = () => {
//     // Extracts pathname property(key) from an object
//     const { pathname } = useLocation();

//     // Automatically scrolls to top whenever pathname changes
//     useEffect(() => {
//         if (pathname.includes("/career-at-eapro-details/")) {
//             window.scrollTo({ top: 500, behavior: "smooth" });

//         }
//         else {
//             window.scrollTo(0, 0);

//         }

//     }, [pathname]);
// }

// export default ScrollToTop;


// import { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// const ScrollToTop = () => {
//   const location = useLocation();

//   useEffect(() => {
//     if (location.pathname.includes("/career-at-eapro-details/")) {
//       window.scrollTo({ top: 500, behavior: "smooth" });
//     } else if (location.state?.scrollTo === "pillars-of-eapro-section") {
//       const el = document.getElementById("pillars-of-eapro-section");
//       if (el) {
//         setTimeout(() => {
//           el.scrollIntoView({ behavior: "smooth" });
//         }, 100); // Small delay to allow DOM to render
//       }
//     } else {
//       window.scrollTo(0, 0);
//     }
//   }, [location]);

//   return null;
// };

// export default ScrollToTop;


import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.includes("/career-at-eapro-details/")) {
      window.scrollTo({ top: 500, behavior: "smooth" });
    } else if (location.state?.scrollTo === "pillars-of-eapro-section") {
      const scrollToElement = () => {
        const el = document.getElementById("pillars-of-eapro-section");
        if (el) {
          const rect = el.getBoundingClientRect();
          // Check if the element is at the correct position
          if (Math.abs(rect.top) > 5) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        } else {
          // Retry until element is found
          requestAnimationFrame(scrollToElement);
        }
      };

      // Start scroll attempt
      requestAnimationFrame(scrollToElement);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return null;
};

export default ScrollToTop;

